<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.3028 0.708251H0.5V9.58693H4.09154C5.09632 9.58693 6.18477 11.9364 6.41801 14.5066L6.4704 15.0833H7.04927C8.20406 15.0833 8.81758 15.0131 9.49828 14.6731C10.5069 14.1675 11.0633 13.1807 11.0633 11.7009V10.4325H13.176C13.882 10.4325 14.5497 10.1114 14.9907 9.55986C15.4317 9.00828 15.5983 8.28601 15.4433 7.59684L14.3025 2.52331C14.0639 1.46216 13.1222 0.708236 12.0352 0.708251H4.3028ZM4.30274 1.97663H12.0351C12.5291 1.97663 12.9572 2.31924 13.0657 2.8015L14.2065 7.87503C14.277 8.18831 14.2013 8.51665 14.0008 8.76741C13.8004 9.01816 13.4969 9.16414 13.176 9.16413H9.79568V11.7009C9.79568 13.2767 9.20583 13.7286 7.61456 13.803C7.23809 10.9712 6.03133 8.51557 4.30274 8.32996V1.97663ZM1.7676 1.97663V8.31855H3.0352V1.97663H1.7676Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
@Component
export default class DislikeIcon extends Vue {}
</script>
